/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { useContext } from "../../../context";

export function Source() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>Source:</label>
      <span>{appointment.source || "N/A"}</span>
    </div>
  );
}
